import { render, staticRenderFns } from "./snaky.vue?vue&type=template&id=e5c3a776&"
import script from "./snaky.vue?vue&type=script&lang=js&"
export * from "./snaky.vue?vue&type=script&lang=js&"
import style0 from "./snaky.vue?vue&type=style&index=0&id=e5c3a776&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports